/* eslint-disable func-names */
/* eslint-disable max-len */
/* eslint-disable no-return-assign */

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Field, reduxForm } from 'redux-form';
import {
  Card, CardBody, Col, ButtonToolbar, Button, Progress,
} from 'reactstrap';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { message } from 'antd';
import { LOCALSTORAGE_TOKEN, LOCALSTORAGE_USERDETAIL } from '../../../../../utils/Types';
import { URL_TOPIC } from '../../../../../utils/EndPoints';

const CreateTopicForm = () => {
  const params = useParams();
  const [progress, setProgress] = useState();
  const [messageApi, contextHolder] = message.useMessage();
  // loading
  const [loading, setLoading] = useState(false);

  const onSubmit = (e) => {
    // setLoading(true);
    e.preventDefault();
    const userDetail = JSON.parse(localStorage.getItem(LOCALSTORAGE_USERDETAIL));
    const data = new FormData();
    data.append('userId', userDetail.id);
    data.append('title', e.target.title.value);
    data.append('order', e.target.order.value);
    data.append('courseId', params.id);
    const token = localStorage.getItem(LOCALSTORAGE_TOKEN);
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${token}`,
      },
      onUploadProgress: () => {
        setProgress(Math.round((100 * data.loaded) / data.total));
      },
    };
    setLoading(true);
    axios.post(URL_TOPIC, data, options)
      .then(() => {
        messageApi.success('New Curriculum Successfully Created');
        window.location.reload();
        setLoading(false);
      }).catch(() => {
        messageApi.error('New Curriculum Failed Created');
      });
  };
  return (
    <Col md={12} lg={12}>
      {contextHolder}
      <Card className="card--not-full-height">
        <CardBody className="dashboard__booking-card">
          <form className="form" onSubmit={onSubmit}>
            <span className="form__form-group-label">Curriculum Order</span>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="order"
                  component="input"
                  type="number"
                  min={0}
                  placeholder="Curriculum order"
                  required
                />
              </div>
            </div>
            <span className="form__form-group-label">Curriculum Title</span>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="title"
                  component="input"
                  type="text"
                  placeholder="Curriculum title"
                  required
                />
              </div>
            </div>
            {loading && (
            <Col md={12} lg={12}>
              <Progress animated value={progress}>{progress}%</Progress>
            </Col>
            )}
            <ButtonToolbar className="form__button-toolbar">
              <Button
                color="primary"
                type="submit"
              >
                Save
              </Button>
            </ButtonToolbar>
          </form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default reduxForm({
  form: 'topic_create', // a unique identifier for this form
})(CreateTopicForm);
